import { render, staticRenderFns } from "./ProjectResultConfig2List.vue?vue&type=template&id=c2a46ce8&scoped=true"
import script from "./ProjectResultConfig2List.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfig2List.vue?vue&type=script&lang=js"
import style0 from "./ProjectResultConfig2List.vue?vue&type=style&index=0&id=c2a46ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a46ce8",
  null
  
)

export default component.exports